// ScriptInjector.js  
import React, { useEffect } from 'react';  

export const ScriptInjector = () => {  
    useEffect(() => {  
        const scriptId = 'content-script'; // Unique ID for the script tag  
        // Check if the script is already injected  
        if (document.getElementById(scriptId)) {  
            console.log('Script already injected.');  
            return; // Prevent re-injection  
        }  

        // Create a new script tag  
        const script = document.createElement('script');  
        script.id = scriptId;  
        // script.src = 'path/to/your/content-script.js'; // Path to your script file or inline script  
        script.async = true;  

        // Append the script to the body or head  
        document.body.appendChild(script);  

        // Log to the console  
        console.log('Content script injected.');  

        // Cleanup function  
        return () => {  
            document.body.removeChild(script); // Remove the script if needed (optional)  
            console.log('Content script removed.');  
        };  
    }, []); // Empty dependency array to run once when the component mounts  

    return null; // No visible output for this component  
};  

export default ScriptInjector;  